/**
 * Returns true if the app is an LFA app
 * keywords: isLfa
 */
const isLfaApp = (): boolean => process.env.IS_LFA === 'true';

export default isLfaApp;
